import React, { Component } from 'react'
import { connect } from 'react-redux';
import { gameActions } from '../../action/GameAction';
import { withTranslation } from 'react-i18next';
class RouletteRight extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stake: 0
        }
    }

    setUpdateStake = (stake) => {
        this.setState({
            stake: stake
        })
        this.props.UpdateStakeAll(stake);
    };

    static getDerivedStateFromProps(props, state) {
        return {
            cartItems: props.cartItems
        };
    }

    removeBetItem = (id) => {
        window.DeleteBetSlip(id);
    };
    removeBetAllItem = () => {
        window.DeleteAllBetSlip();
        this.setState({ showcart: 0 });
    };

    render() {
        const { t } = this.props;
        return (
            <div>
                <div className={`lottoRht scrollbar ${this.state.showcart == 1 ? 'show' : ''}`}>
                    <div class="rhtSecInrContent">
                        <div class="betSlipHead bg3">
                            <h2>All Bet<small>{this.state.cartItems.length}</small></h2>
                            <span onClick={() => { this.setState({ showcart: 0 }) }} class="rlt-close-btn"><img src="./assets/img/icons/chat-bot-close.png" /></span>
                        </div>
                        <div class="betslipContent">
                            {/*     <div class="betSlipTop">
                                    <div class="nxtDrawCont">
                                        <div class="heading">
                                            <h4>{t('lblgameslip')}</h4>
                                        </div>
                                    </div>
                                    <a class="betClear" onClick={() => { this.removeBetAllItem() }}></a>
                                </div> */}
                            {this.state.cartItems && this.state.cartItems.length <= 0 &&
                                <div className="betError2">
                                    <h2 className="warningMsg bounceIn animated infinite">{t('lblplcurbet')}</h2>
                                </div>}
                            <div className="betSlip">
                                <div className="betSlipContWrap">
                                    <ul className="rtebetSlipCont betSlipCont roulette-betSlipCont scrollbar">
                                        {this.state.cartItems && this.state.cartItems.map((x, indx) =>
                                            <li style={{ display: 'block' }} className="rtetoggle" key={`bet_${indx}`}>
                                                <div class="rtebetSlipLiTop">
                                                    <span class="rtedrawNumber">Draw No : #{x.drawNo}</span>
                                                </div>
                                                <div class="rtebetSlipLi">
                                                    <div class="rtebetSlipLiCont">
                                                        <span class="rtebetValue">{x.dispName}</span>
                                                    </div>
                                                    <div class="rtebetSlipLiCont1">
                                                        <span class="rtebetValue">{x.stakeValue}</span>
                                                    </div>
                                                    <div class="rtebetSlipLiCont2">
                                                        <span class="rtebetValueEntr2Lft">{x.total}</span>
                                                        <span class="rtebetValueEntr2Rht">{x.oddsValue}X</span>
                                                    </div>
                                                </div>
                                                <span class="betLiclose" onClick={() => { this.removeBetItem(x.id) }}><img src="./assets/img/icons/del.png" /></span>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                            <div class="betsTbl">
                                {/* <div class="enterBetValBtom">
							<span>ENTER STAKE VALUE</span>
							<input type="text" placeholder="00.00" value={this.state.stake} onChange={(e) => this.setUpdateStake(e.target.value)}/>
						</div> */}
                                <ul class=""><li class="">
                                    <span class="betsTblHead">Bets</span>
                                    <span class="betsTblHead">Total Stake</span>
                                </li>
                                    <li class="border-color-bottom">
                                        <span class="betsTblCell">{this.state.cartItems.length}</span>
                                        <span class="betsTblCell">({this.state.cartItems.reduce((a, b) => a = a + b.stakeValue, 0)})</span>
                                    </li>
                                </ul>
                                <div class="betBtnSec">
                                    <a class="allClearBtn" onClick={() => { this.removeBetAllItem() }}>{t('lblclear')}</a>
                                    <a class="allClearBtn" onClick={() => { this.props.buyLotteryBet();this.setState({ showcart: 0 }); }}>{t('lblBuy')}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.showcart != 1 && <div onClick={() => { this.setState({ showcart: 1 }) }}><button>{t('lblBuy')}</button></div>}
            </div >
        );
    }
}


function mapStateToProps(state) {
    const { user } = state.loginReducer;
    const { cartItems } = state.gameReducer;
    return { user, cartItems };
}

const mapActionToProps = {
    UpdateStakeAll: gameActions.UpdateStakeAll,
    UpdateCartAll: gameActions.UpdateCartAll,
    RemoveFromCart: gameActions.RemoveFromCart
}

export default connect(mapStateToProps, mapActionToProps)(withTranslation()(RouletteRight))